import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Flower2, Calendar, BookOpen, Download } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    Icon: Flower2,
    text: '60+ clases listas para usar'
  }, {
    Icon: Calendar,
    text: 'Más de 100 secuencias profesionales'
  }, {
    Icon: BookOpen,
    text: 'Recursos imprimibles'
  }, {
    Icon: Download,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-5 pb-12 lg:pt-12 lg:pb-20 bg-transparent overflow-hidden" data-id="element-93">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-50 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3 opacity-70 pointer-events-none" data-id="element-94"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-brand-50 text-brand-700 font-medium text-[11px] sm:text-xs uppercase tracking-widest mb-6 border border-brand-100/50" data-id="element-97">
            🧘 Para profesores de Yoga
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-serif font-medium text-ink-900 leading-[1.1] mb-6 tracking-tight" data-id="element-98">
            Resolvé todo tu{' '}
            <span className="text-brand-600 italic" data-id="element-99">año de Yoga</span> en 5
            minutos
          </h1>
        </motion.div>

        {/* Product mockup image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mb-10 mt-8" data-id="element-100">
          <div className="absolute inset-0 bg-brand-100/50 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-101"></div>

          {/* Elegant Editorial Mockup */}
          <div className="relative z-10 w-full max-w-[280px] sm:max-w-md lg:max-w-2xl mx-auto h-56 sm:h-72 lg:h-96 flex items-center justify-center" data-id="element-102">
            {/* Back Book */}
            <div className="absolute w-3/4 h-5/6 bg-accent-50 rounded-r-2xl rounded-l-sm shadow-md border border-accent-100/50 transform translate-x-4 -translate-y-4 rotate-3 opacity-80" data-id="element-103"></div>
            {/* Middle Book */}
            <div className="absolute w-3/4 h-5/6 bg-white rounded-r-2xl rounded-l-sm shadow-lg border border-brand-50 transform translate-x-2 -translate-y-2 rotate-1" data-id="element-104"></div>
            {/* Front Book */}
            <div className="relative w-3/4 h-5/6 bg-[#FAF8F5] rounded-r-2xl rounded-l-sm shadow-xl border border-accent-200/40 flex flex-col items-center justify-center p-6 overflow-hidden" data-id="element-105">
              {/* Decorative border inside */}
              <div className="absolute inset-2 border border-accent-300/30 rounded-r-xl rounded-l-sm pointer-events-none" data-id="element-106"></div>
              <div className="relative z-10 text-center" data-id="element-107">
                <h3 className="text-accent-600 font-medium text-xs sm:text-sm uppercase tracking-[0.3em] mb-4" data-id="element-108">
                  Mega Pack
                </h3>
                <h2 className="text-brand-900 font-serif font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6" data-id="element-109">
                  Yoga Listo
                  <br data-id="element-110" />
                  <span className="italic text-brand-600" data-id="element-111">2026</span>
                </h2>
                <div className="inline-block bg-brand-50 text-brand-700 font-medium px-4 py-1.5 rounded-full text-xs sm:text-sm tracking-wide" data-id="element-112">
                  6 Tomos Incluidos
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-113">
          <p className="text-base sm:text-lg lg:text-xl text-ink-600 mb-8 leading-relaxed max-w-3xl mx-auto font-light" data-id="element-114">
            Mega Pack Yoga Listo 2026 — 6 tomos completos. 6 bonos exclusivos.
            Todo el material que necesitás para planificar clases de Yoga,
            acompañar alumnos, crear secuencias profesionales y organizar tu
            actividad durante todo el año.
          </p>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-700 hover:bg-brand-800 text-white text-base sm:text-lg font-medium py-4 sm:py-5 px-8 sm:px-10 rounded-full shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-3 tracking-wide" data-id="element-115">
            QUIERO ACCEDER AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-116" />
          </button>

          <p className="mt-4 text-xs sm:text-sm text-ink-400 font-medium tracking-wide" data-id="element-117">
            🔒 Pago 100% seguro · Garantía de 7 días
          </p>

          {/* Trust badges */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-12 max-w-4xl mx-auto" data-id="element-118">
            {badges.map((b, i) => {
            const Icon = b.Icon;
            return <div key={i} className="flex items-center gap-3 text-xs sm:text-sm font-medium text-ink-700 bg-white/50 backdrop-blur-sm border border-brand-100/30 px-4 py-3 rounded-2xl shadow-sm" data-id="element-119">
                  <div className="w-8 h-8 rounded-full bg-brand-50 text-brand-600 flex items-center justify-center shrink-0" data-id="element-120">
                    <Icon className="w-4 h-4" strokeWidth={1.5} data-id="element-121" />
                  </div>
                  <span className="text-left leading-snug" data-id="element-122">{b.text}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}